import { Trans } from 'react-i18next';

import { getActorName } from '../BusinessLogItem.util';
import { TransCuriosityLookup } from '../TransCuriosityLookup/TransCuriosityLookup';
import { TlscpLogEntry } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';

export const MetaInformation = ({
  actorId,
  actorVariant,
  createdAt,
}: Pick<TlscpLogEntry, 'actorId' | 'actorVariant' | 'createdAt'>) => {
  return (
    <Trans
      ns={I18nNamespace.businessLog}
      i18nKey="meta_information"
      values={{ context: actorVariant, createdAt }}
      components={{
        lookup: <TransCuriosityLookup context={{ actorId }} valueGetter={getActorName} />,
      }}
    />
  );
};
